<template>
  <!-- 学原著 -->
  <el-carousel
          :autoplay="false"
          arrow="always"
          indicator-position="none"
          ref="cardShow"
        >
          <el-carousel-item v-for="(item, index) in writingData" :key="index">
            <ul class="list">
              <li v-for="(it, index) in item" :key="index">
                <!-- 网站版和镜像版一样 -->
                <a :href="it.linkUrl" target="_blank">
                  <img :src="downloadUrl + it.imageUrl" alt="" />
                  <p class="txt-overflow" :title="it.buildTitle">{{ it.buildTitle }}</p>
                </a>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
</template>
<script>
export default {
  props: ["downloadUrl"],
  data() {
    return {
      writingData: [], //学习著作
      total:0
    };
  },
  created() {
    this.getWritingData(); //学习著作
  },
  methods: {
    //学习著作
    getWritingData(total) {
        this.axios.post("data/custom/buildlist",{
        uid: '41a41bf3-3e5a-4ece-88bd-0634137d7174',
        pageNum: 1,
        pageSize: total ? total : 10
      }).then((res) => {
        if (res.status == 200) {
          if(!total) {
            this.total = res.data.total
            this.getWritingData(this.total)
            return
          }
          let data = res.data.rows;
          let newCardList = [];
          for (var i = 0; i < data.length; i += 5) {
            newCardList.push(data.slice(i, i + 5));
          }

          this.writingData = newCardList;
        } else {
          console.log("获取学习著作失败！");
          this.$message.error("获取学习著作失败！");
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep{
 .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    font-family: "iconfont" !important;
  }
  .el-icon-arrow-left:before {
    content: "\e63f";
  }
  .el-icon-arrow-right:before {
    content: "\e718";
  }
 .el-carousel__arrow {
    background: none;
    color: #bd1a2d;
    font-size: 36px;
    border: none;
    width: auto;
    height: auto;
    &:hover {
      background: none;
    }
  }
  .el-carousel__arrow--left {
    left: -75px;
  }
  .el-carousel__arrow--right {
    right: -75px;
  }
}
  .el-carousel {
    position: relative;
    padding: 0 93px;
    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 100%;
    }
    &::before {
      bottom: 20px;
      width: 93%;
      height: 60px;
      margin: 0 auto;
      background: linear-gradient(180deg, #fff0e6 0%, #ffcccb 100%);
      -webkit-transform: perspective(0.5em) rotateX(5deg);
      transform: perspective(3em) rotateX(5deg);
      left: 3.5%;
    }
    &::after {
      height: 20px;
      left: 0;
      bottom: 0;
      background: #ffb9b8;
      box-shadow: 0px 6px 14px rgba(192, 106, 105, 0.48);
    }
  }
  .list {
  font-size: 16px;
  display: flex;
  li {
    flex: 1;
    padding: 0 12.5px;
    filter: drop-shadow(0px 8px 11px rgba(237, 96, 96, 0.25));
    a {
      width: 161px;
      height: 242px;
      &:hover {
        color: #de1c26;
      }
      img {
        width: 100%;
        height: 242px;
        margin-bottom: 10px;
      }
    }
  }
}
// 学习著作
.journal {
  padding-top: 31px;
  padding-bottom: 38px;
  .journal-con {
    padding-top: 38px;
    li {
      float: left;
      width: 240px;
      a {
        width: 209px;
        margin: 0 auto;
        display: block;
        img {
          width: 209px;
          height: 286px;
          border-radius: 10px;
          box-shadow: -1px 5px 5px 0px rgba(207, 205, 205, 0.75);
        }
        p {
          line-height: 32px;
          font-size: 15px;
          color: #333;
          text-align: center;
          margin-top: 14px;
        }
        &:hover p {
          color: #f70;
        }
      }
    }
  }
}
</style>
